

































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { getCookie } from "@szgc/plt-core-v2";
import Api from "../../api/index";
import request from "../../api/request";
// import BpmnViewer from "bpmn-js/lib/Viewer";
import BpmnViewer from "bpmn-js/lib/NavigatedViewer";
import "bpmn-js/dist/assets/bpmn-js.css";
import "bpmn-js/dist/assets/diagram-js.css";
import "bpmn-js/dist/assets/bpmn-font/css/bpmn.css";
import { ElementLike } from "diagram-js/lib/core/Types";
import Canvas from "diagram-js/lib/core/Canvas";
@Component({
  name: "WbenProgressChart",
  components: {}
})
export default class WbenProgressChart extends Vue {
  @Prop({
    type: Object,
    default() {
      return null;
    }
  })
  private dataAll!: any;

  private processData: any = null;
  private imgUrl: any = "";
  private prefix: string = "";
  private tooltipPosition = {
    left: `0px`,
    top: `0px`
  };
  private showTooltip = false;
  private tooltipInfo: any = {};

  @Watch("dataAll", { immediate: true, deep: true })
  private async getData(newVal: any) {
    if (newVal) {
      this.prefix = getCookie("plt-api-route") || "";
      this.processData = JSON.parse(JSON.stringify(newVal));
      if (
        this.dataAll.run.execStatus === -1 &&
        (this.dataAll.run.sendStatus === 0 ||
          this.dataAll.run.sendStatus === 1 ||
          this.dataAll.run.sendStatus === 2)
      ) {
        // 待发状态显示图片
        this.imgUrl = `${this.prefix}/api/appproc/packages/${this.processData.pacId}/flows/${
          this.processData.flowCfgId
        }/image.png?_time=${new Date().getTime()}`;
      }
    }
  }
  async getFlowData() {
    try {
      const { success, data, message } = await request({
        url:
          this.prefix +
          Api.getFlowsTasksInfo(
            this.processData.pacId,
            this.processData.flowCfgId,
            this.processData.businessId
          ),
        method: "get"
      });
      if (!success) {
        this.$message.error("获取流程图信息失败:" + message);
        return false;
      }
      return data;
    } catch (error: any) {
      this.$message.error("获取流程图信息失败:" + error);
      return false;
    }
  }
  async initBpmnViewer(data: any) {
    const viewer = new BpmnViewer({
      container: this.$refs.canvas as HTMLElement
    });
    await viewer.importXML(data.modelDataCfg);
    const canvas = viewer.get<Canvas>("canvas");
    canvas.zoom("fit-viewport");
    this.setBpmnViewerColor(data);
    this.initBpmnViewerEvent(viewer, data);
  }
  setBpmnViewerColor(data: any) {
    // // 转换为matterTaskTodoUserName的Map形式
    // const matterTaskDoneUserName = Array.isArray(data.matterTaskDoneUserName) ? (data.matterTaskDoneUserName as any[]).reduce((prev,current) => {
    //   prev[current.key] = true;
    //   return prev
    // },{}) : {};

    data.executedHighLightedActivities = this.removeElementsBetweenDuplicate([
      ...data.executedHighLightedActivities,
      (data.matterTaskTodoUserName as Record<string, unknown>[])[0]?.key
    ]);

    // 已执行节点颜色
    (data.executedHighLightedActivities as any[]).forEach((id: string) => {
      // if (!matterTaskDoneUserName[id]) {
      //   return
      // }
      const ele = document.querySelector(`[data-element-id=${id}] .djs-visual :first-child`);
      if (ele instanceof SVGElement) {
        ele.style.stroke = `rgb(${data.executedColor.red},${data.executedColor.green},${data.executedColor.blue})`;
      }
      if (ele instanceof SVGPolygonElement && ele.nextSibling instanceof SVGPathElement) {
        ele.nextSibling.style.stroke = `rgb(${data.executedColor.red},${data.executedColor.green},${data.executedColor.blue})`;
        ele.nextSibling.style.fill = `rgb(${data.executedColor.red},${data.executedColor.green},${data.executedColor.blue})`;
      }
    });

    // 当前节点颜色
    (data.executionHighLightedActivities as any[]).forEach((id: string) => {
      const ele = document.querySelector(`[data-element-id=${id}] .djs-visual rect:first-child`);
      if (ele instanceof SVGElement) {
        ele.style.stroke = `rgb(${data.executionColor.red},${data.executionColor.green},${data.executionColor.blue})`;
      }
    });
    // data.executedHighLightedFlows = this.removeElementsBetweenDuplicate(data.executedHighLightedFlows);
    // // 连线颜色
    // (data.executedHighLightedFlows as any[]).forEach((id: string) => {
    //   const ele = document.querySelector(`[data-element-id=${id}] .djs-visual :first-child`);
    //   if (ele instanceof SVGElement) {
    //     ele.style.stroke = `rgb(${data.executedColor.red} ,${data.executedColor.green} ,${data.executedColor.blue})`;
    //     ele.style.markerEnd = `url(#sequenceflow-end-user)`;
    //   }
    // });
    // 添加新的箭头marker
    const defs = document.createElement("defs");
    const markerInner = `<marker id="sequenceflow-end-user" viewBox="0 0 20 20" refX="11" refY="10" markerWidth="10" markerHeight="10" orient="auto"><path d="M 1 5 L 11 10 L 1 15 Z" style="stroke-linecap: round; stroke-linejoin: round; stroke: rgb(${data.executedColor.red} ,${data.executedColor.green} ,${data.executedColor.blue}); stroke-width: 1px; fill: rgb(${data.executedColor.red} ,${data.executedColor.green} ,${data.executedColor.blue});"></path></marker>`;
    defs.innerHTML = markerInner;
    const svg = document.querySelector(`svg[data-element-id=${this.processData.flowCfgId}]`);
    if (svg instanceof SVGElement) {
      svg.appendChild(defs);
    }
    defs.outerHTML = `${defs.outerHTML}`; // 触发svg更新
  }
  removeElementsBetweenDuplicate(arr: string | number[]) {
    try {
      if (Array.isArray(arr)) {
        let resArr: Array<string | number | undefined> = [];
        let resArrMap: Record<string | number, number> = {}; // 记录数组的元素下标
        const getArrIndexMap = (arr: Array<string | number | undefined>) =>
          arr.reduce((prev, item, index) => {
            if (item !== undefined && prev[item] === undefined) {
              prev[item] = index;
            }
            return prev;
          }, {} as Record<string | number, number>);
        arr.forEach((item, index) => {
          if (resArrMap[item] === undefined) {
            // 如果resArr没出现该item则push
            resArr.push(item);
            resArrMap[item] = index; // 记录数组的每一个元素第一次出现的index
          } else {
            /**
             * 处理这样的情况
             * @example [1,2,3,2] => [1,2]
             * @example [1,2,3,2,4,5,4] => [1,2,4]
             */
            resArr = resArr.map((item2, index2) => {
              if (index2 > resArrMap[item] && index2 <= index) {
                return undefined;
              }
              return item2;
            });
            resArr.push(undefined);
            resArrMap = getArrIndexMap(resArr);
          }
        });
        return resArr.filter((item) => item !== undefined);
      }
    } catch (error) {
      console.error(error);
      return arr;
    }

    return arr;
  }
  initBpmnViewerEvent(viewer: BpmnViewer, data: any) {
    const nodeInfoList = [
      ...(data.matterTaskTodoUserName || []),
      ...(data.matterTaskDoneUserName || [])
    ];
    const tooltipMap = [
      ...(data.executionHighLightedActivities || []),
      ...(data.executedHighLightedActivities || [])
    ].reduceRight((prev, key) => {
      const item = nodeInfoList.find((item) => item.key === key);
      if (item) {
        prev[key] = item;
      }

      return prev;
    }, {});
    viewer.on<{ element: ElementLike }>("element.hover", (e: any) => {
      if (e.element.id && tooltipMap[e.element.id]) {
        const { left, top } = e.gfx.getBoundingClientRect();
        this.tooltipPosition = {
          left: `${left}px`,
          top: `${top}px`
        };
        this.showTooltip = true;
        this.tooltipInfo = tooltipMap[e.element.id];
      }
    });
    viewer.on<{ element: ElementLike }>("element.out", () => {
      this.showTooltip = false;
    });
  }
  async mounted() {
    if (!this.dataAll) return;
    if (
      this.dataAll.run.execStatus === -1 &&
      (this.dataAll.run.sendStatus === 0 ||
        this.dataAll.run.sendStatus === 1 ||
        this.dataAll.run.sendStatus === 2)
    ) {
      // 待发状态显示图片
      this.imgUrl = `${this.prefix}/api/appproc/packages/${this.processData.pacId}/flows/${
        this.processData.flowCfgId
      }/image.png?_time=${new Date().getTime()}`;
    } else {
      this.imgUrl = "";
      const data = await this.getFlowData();
      if (!data) return;
      this.initBpmnViewer(data);
    }
  }

  /*打印*/
  print() {
    //判断iframe是否存在，删除之前的iframe
    let iframe: any = document.getElementById("wenbchPrintIframe");
    if (iframe) {
      document.body.removeChild(iframe);
    }
    const el: any = document.getElementById("wbenchPrintBox");
    iframe = document.createElement("IFRAME");
    iframe.setAttribute("id", "wenbchPrintIframe");
    iframe.setAttribute(
      "style",
      "position:absolute;width:0;height:0;overflow:hidden;left:-500px;top:-500px;"
    );
    document.body.appendChild(iframe);
    const doc: any = iframe.contentWindow.document;
    //这里可以自定义样式
    //doc.write("<LINK rel="stylesheet" type="text/css" href="css/print.css">");
    //去掉页眉页脚
    doc.write(`<style type="text/css">
      @page {
        size: auto;  /* auto is the initial value */
        margin: 0; /* this affects the margin in the printer settings */
      }
      </style>`);
    doc.write("<div style='text-align: center;font-size: 30px;'>流程模板图</div>");
    doc.write("<div>" + el.innerHTML + "</div>");
    doc.close();
    iframe.contentWindow.focus();
    setTimeout(() => {
      iframe.contentWindow.print();
    }, 500);
  }
}
